import React from "react";
import Dashboard from "./Dashboard";

export default function DashboardModal({closeClickFunction, chatId=null}) {
    return (
        <div className="dashboard-background">
            <Dashboard closeClickFunction={closeClickFunction} chatId={chatId} />
        </div>
    )
}
